// source: livongo/protobuf/common/bh/complaint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.com.livongo.protobuf.common.bh.Complaint', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.common.bh.Complaint.Values', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.common.bh.Complaint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.common.bh.Complaint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.common.bh.Complaint.displayName = 'proto.com.livongo.protobuf.common.bh.Complaint';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.common.bh.Complaint.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.common.bh.Complaint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.common.bh.Complaint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.Complaint.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.common.bh.Complaint}
 */
proto.com.livongo.protobuf.common.bh.Complaint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.common.bh.Complaint;
  return proto.com.livongo.protobuf.common.bh.Complaint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.common.bh.Complaint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.common.bh.Complaint}
 */
proto.com.livongo.protobuf.common.bh.Complaint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.common.bh.Complaint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.common.bh.Complaint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.common.bh.Complaint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.common.bh.Complaint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.common.bh.Complaint.Values = {
  INVALID: 0,
  TRAUMA: 1,
  PARENTING: 2,
  SLEEP: 3,
  PAIN: 4,
  OPIOID: 5,
  DRUGS_OR_ALCOHOL: 6,
  DEPRESSION: 7,
  PANIC: 8,
  ANXIETY: 9,
  IMPULSIVITY: 10,
  ANGER: 11,
  SMI: 12,
  NICOTINE: 13,
  RELATIONSHIPS: 14,
  PERFORMANCE: 15,
  MINDFULNESS: 16,
  STRESS: 17,
  BIPOLAR: 18,
  GRIEF: 19,
  DIVORCE: 20,
  LIFE_CHANGE: 21,
  WORK_LIFE_BALANCE: 22
};

goog.object.extend(exports, proto.com.livongo.protobuf.common.bh);
